import React from 'react';
import { useIntl } from 'react-intl';
import { Evidence } from '@eas/common-web';
import { useAuthoredEvidence } from '@composite/evidence/authored-evidence';
import { Certificate } from '@models';
import { EntityName, EvidenceApiUrl } from '@enums';
import { useColumns } from './certificates-columns';
import { Fields } from './certificates-fields';
import { useValidationSchema } from './certificates-schema';

export function Certificates() {
  const validationSchema = useValidationSchema();
  const intl = useIntl();
  const columns = useColumns();

  const evidence = useAuthoredEvidence<Certificate>({
    version: 1,
    identifier: 'CERTIFICATES',
    apiProps: {
      url: EvidenceApiUrl.CERTIFICATES,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'ES__DICT_CERTIFICATES__TABLE__TITLE',
        defaultMessage: 'Certifikáty',
      }),
      showBulkActionButton: false,
      showNamedSettingsButton: false,
    },
    detailProps: {
      entityName: EntityName.CERTIFICATE,
      validationSchema,
      GeneralFieldsComponent: Fields,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ES__CERTIFICATES__DETAIL__TITLE',
          defaultMessage: 'Certifikát',
        }),
        subtitle: (c) => c?.name ?? '',
      },
    },
  });

  return <Evidence {...evidence} />;
}
